// extracted by mini-css-extract-plugin
export default {"division1":"SelContent11_division1__TC2o0","imgdata1":"SelContent11_imgdata1__8H+tC","imgdata2":"SelContent11_imgdata2__7BJfQ"};